import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { requireModules } from '../../../route';
import { Route as procurementFiltersRoute } from '../../filters/route';
import { demandDetailSearchSchema } from '../demand/demandFilters';

const ForecastDetailsPage = lazyRouteComponent(
  () => import('../ForecastDetailsPage'),
  'ForecastDetailsPage',
);

export const Route = createRoute({
  // Under the procurement filter route, which owns the shared filters.
  getParentRoute: () => procurementFiltersRoute,
  path: '/procurement/forecast/details',
  /**
   * The grid's own search plus the series this page is pinned to, so the two
   * routes read each other's URLs and a trip in either direction keeps every
   * filter the buyer had set.
   */
  validateSearch: demandDetailSearchSchema,
  staticData: {
    app: {
      nav: {
        label: msg('Forecast details', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <MagnifyingGlassIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 40,
        groupOrder: 30,
        // Reached by clicking an item on the grid, which is the only place you
        // have a series in mind. Addable for anyone who lives on this screen.
        defaultHidden: true,
      },
      // Stable id: the route id changed when it moved under the filter route.
      performance: { pageId: 'forecast-details', readiness: 'route-rendered' },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: ForecastDetailsPage,
  loader: () => ({
    crumb: msg('Forecast details', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
